function Dots({ kinds }: { kinds: ('up' | 'down')[] }) {
  return (
    <span className="flex items-center gap-1.5" aria-hidden="true">
      {kinds.map((k, i) => (
        <span key={i} className={`size-2.5 rounded-full ${k === 'down' ? 'bg-status-down' : 'bg-status-up'}`} />
      ))}
    </span>
  )
}

export function FailureTable({ className = 'mx-auto mt-5 max-w-3xl' }: { className?: string }) {
  const scenarios = [
    { name: 'DNS timeout', kinds: ['down', 'up'] as const, outcome: 'No alert', detail: 'The re-check passes. You sleep through it.' },
    { name: 'Server down', kinds: ['down', 'down', 'down'] as const, outcome: 'Alert sent', detail: '3 consecutive failures confirmed. Slack, email, Telegram.' },
  ]
  return (
      <div className={`${className} rounded-lg border border-border bg-card`}>
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <h3 className="text-sm font-semibold text-foreground">Consecutive failures</h3>
          <span className="text-xs text-muted-foreground">Example data</span>
        </div>
        <ul className="divide-y divide-border">
          {scenarios.map((s) => (
            <li key={s.name} className="grid grid-cols-[7rem_1fr] items-center gap-x-4 gap-y-1 px-4 py-3.5 sm:grid-cols-[8rem_4.5rem_1fr]">
              <span className="text-sm font-medium text-foreground">{s.name}</span>
              <Dots kinds={[...s.kinds]} />
              <span className="col-span-2 text-sm text-body sm:col-span-1">
                <span className="font-medium text-foreground">{s.outcome}.</span> {s.detail}
              </span>
            </li>
          ))}
        </ul>
      </div>
  )
}
